import React from "react";
import { ThumbsUp, ThumbsDown } from "lucide-react";
import { getHelpCenterUrl } from "../../lib/utils";

export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatRelativeTime = (dateString: string): string => {
  const date = new Date(dateString);
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (diffInSeconds < 60) {
    return "just now";
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return `${diffInMinutes} ${diffInMinutes === 1 ? "minute" : "minutes"} ago`;
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return `${diffInHours} ${diffInHours === 1 ? "hour" : "hours"} ago`;
  }

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) {
    return `${diffInDays} ${diffInDays === 1 ? "day" : "days"} ago`;
  }

  const diffInWeeks = Math.floor(diffInDays / 7);
  if (diffInWeeks < 4) {
    return `${diffInWeeks} ${diffInWeeks === 1 ? "week" : "weeks"} ago`;
  }

  const diffInMonths = Math.floor(diffInDays / 30);
  if (diffInMonths < 12) {
    return `${diffInMonths} ${diffInMonths === 1 ? "month" : "months"} ago`;
  }

  const diffInYears = Math.floor(diffInDays / 365);
  return `${diffInYears} ${diffInYears === 1 ? "year" : "years"} ago`;
};

export const getRatingIcon = (rating: number | null): React.ReactNode => {
  if (rating === 1) {
    return <ThumbsUp className="h-4 w-4 text-green-600" />;
  } else if (rating === 0) {
    return <ThumbsDown className="h-4 w-4 text-red-600" />;
  }
  return <span className="text-muted-foreground">—</span>;
};

export const getItemUrl = (feedbackItem: any): string | null => {
  const helpCenter = feedbackItem.help_center;
  if (!helpCenter?.slug || !feedbackItem.item) return null;

  const { feedback_type, item } = feedbackItem;

  if (feedback_type === "article" && item.slug) {
    return getHelpCenterUrl(helpCenter.slug, `/${item.slug}`);
  } else if (feedback_type === "category" && item.slug) {
    return getHelpCenterUrl(helpCenter.slug, `/${item.slug}`);
  } else if (feedback_type === "guide") {
    // For guides, we don't have the full path, so just link to help center home
    // User can navigate from there
    return getHelpCenterUrl(helpCenter.slug, "/");
  }

  return null;
};

